import { toast } from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { BASE_URL, apiService } from '../../services/service';
import * as prodTypes from '../actionTypes';

export const get_wishlist = () => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_WISHLIST });

        const response = await apiService.get(`${ApiEndpoints.GET_WISHLIST}`);

        if (response.status === 'success') {
            dispatch({
                type: prodTypes.GET_WISHLIST_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.GET_WISHLIST_FAIL, payload: message });
    }
};

export const add_to_wishlist = (data) => async (dispatch) => {
    const body = {
        productId: data.item_id,
    };
    try {
        dispatch({ type: prodTypes.ADD_TO_WISHLIST });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.ADD_TO_WISHLIST}`,
            payload: body,
        });

        if (response.status === 'success') {
            await dispatch({
                type: prodTypes.ADD_TO_WISHLIST_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Network Error';
        dispatch({ type: prodTypes.ADD_TO_WISHLIST_FAIL, error: message });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const remove_from_wishlist = (data) => async (dispatch) => {
    const body = {
        productId: data,
    };
    try {
        dispatch({ type: prodTypes.REMOVE_FROM_WISHLIST });
        const response = await apiService.put({
            url: ApiEndpoints.REMOVE_FROM_WISHLIST,
            payload: body,
        });
        if (response.status === 'success') {
            dispatch({
                type: prodTypes.REMOVE_FROM_WISHLIST_SUCCESS,
                payload: response.data,
            });
            dispatch(get_wishlist());
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.REMOVE_FROM_WISHLIST_FAIL, payload: message });
    }
};

export const delete_from_wishlist = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.DELETE_FROM_WISHLIST });
        dispatch({
            type: prodTypes.DELETE_FROM_WISHLIST_SUCCESS,
            payload: data,
        });
        dispatch(get_wishlist());
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.DELETE_FROM_WISHLIST_FAIL, payload: message });
    }
};
